interface SearchProps {
  searchValue: string;
  handleChange: (value: string) => void;
}

const ServiceSearch: React.FC<SearchProps> = ({
  searchValue,
  handleChange,
}) => {
  return (
    <label className="input bg-white dark:bg-black rounded-full flex items-center gap-2">
      <svg
        width={16}
        height={16}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M21.75 20.6895L16.086 15.0255C17.4471 13.3914 18.1258 11.2956 17.981 9.17389C17.8361 7.05219 16.8789 5.06801 15.3084 3.6341C13.7379 2.2002 11.675 1.42697 9.54893 1.47528C7.42284 1.52359 5.39723 2.38971 3.89347 3.89347C2.38971 5.39723 1.52359 7.42284 1.47528 9.54893C1.42697 11.675 2.2002 13.7379 3.6341 15.3084C5.06801 16.8789 7.05219 17.8361 9.17389 17.981C11.2956 18.1258 13.3914 17.4471 15.0255 16.086L20.6895 21.75L21.75 20.6895ZM2.99996 9.74996C2.99996 8.41494 3.39585 7.1099 4.13754 5.99987C4.87924 4.88983 5.93345 4.02467 7.16685 3.51378C8.40025 3.00289 9.75745 2.86921 11.0668 3.12966C12.3762 3.39011 13.5789 4.03299 14.5229 4.97699C15.4669 5.921 16.1098 7.12373 16.3703 8.4331C16.6307 9.74248 16.497 11.0997 15.9862 12.3331C15.4753 13.5665 14.6101 14.6207 13.5001 15.3624C12.39 16.1041 11.085 16.5 9.74996 16.5C7.96036 16.498 6.24463 15.7862 4.97919 14.5207C3.71375 13.2553 3.00195 11.5396 2.99996 9.74996Z"
          fill="#8B8B8D"
        />
      </svg>

      <input
        type="text"
        className="grow"
        placeholder="Find plumbers, cleaners, electricians"
        value={searchValue}
        onChange={(e) => handleChange(e.target.value)}
      />
    </label>
  );
};

export default ServiceSearch;
